import Main from '@/pages/Pay/Main'
import Record from '@/pages/Pay/Record'
import Step1 from '@/pages/Pay/Step1'
import Step2 from '@/pages/Pay/Step2'
import Step3 from '@/pages/Pay/Step3'
import Tips from '@/pages/Pay/Tips'
import Detail from '@/pages/Pay/Detail'
import Charge from '../pages/Pay/Charge'
import PrePaid from '../pages/Pay/PrePaid'
import packPay from '../pages/Pay/packPay'

export default [{
    path: '',
    component: Main,
    redirect: 'home'
}, {
    path: 'home',
    component: Main,
    children: [{
        path: '',
        component: Step1
    }, {
        path: 'step1',
        component: Step1
    }, {
        path: 'step2',
        component: Step2
    }, {
        path: 'step3',
        component: Step3
    }]
}, {
    path: 'record',
    component: Record
}, {
    path: 'charge',
    component: Charge
}, {
    path: 'detail',
    component: Detail
}, {
    path: 'tips',
    component: Tips
}, {
    path: 'prepaid',
    component: PrePaid
}, {
    path: 'packpay',
    component: packPay
}]
